import moment from "moment";
import { DocTimestamp } from "../db/models/extra";
import firebase from "firebase/compat/app";

export const docTimestampToDate = (timestamp: DocTimestamp | null) => {
    if(!timestamp) return null;

    return moment(timestamp.seconds * 1000).toDate();
}

export const dateToDocTimestamp = (date: Date | null) => {
    if(!date) return null;

    return firebase.firestore.Timestamp.fromDate(date);
}

export const endOfDayAsDate = (date: Date | null) => {
    if(!date) return null;

    return moment(date).endOf('day').toDate();
}

export const docTimestampToString = (format: string, timestamp?: DocTimestamp) => {
    if(!timestamp || !format) return "";

    return moment(timestamp.seconds * 1000).format(format);
}